import http from "./http";

function getVehicleDetails(data) {
  return http.post(`district_wisevehicleList`, data);
}
function addVehicleDetails(data) {
  return http.post(`addVehicle`, data);
}
function updateVehicleDetails(data) {
  return http.post(`updateVehicle`, data);
}
function deleteVehicleDetails(data) {
  return http.post(`deleteVehicle`, data);
}

function getVehicleList(data) {
  return http.post(`vehicleList`, data);
}

function yearlyAnalytics(data) {
  return http.post(`topAvgSpeed`, data);
}

function customAnalytics(data) {
  return http.post(`tripgraphData`, data);
}

function fetct_Agency_trip_data(data) {
  return http.post(`AgencyTripData`, data);
}

function fetch_distict_vehicle(data) {
  return http.post(`district_wisevehicleList`, data);
}

function fetch_distict_vehicle_with_last_location(data) {
  return http.post(`district_wisevehicleListWithLastLocation`, data);
}

function fetch_vehicle_for_nearby(data) {
  return http.post(`last_five_minVehicle_record`, data);
}

const VehicleDetailsService = {
  getVehicleDetails,
  addVehicleDetails,
  updateVehicleDetails,
  deleteVehicleDetails,
  getVehicleList,
  yearlyAnalytics,
  customAnalytics,
  fetct_Agency_trip_data,
  fetch_distict_vehicle,
  fetch_vehicle_for_nearby,
  fetch_distict_vehicle_with_last_location,
};

export default VehicleDetailsService;
